import { getCountryIconUrl } from "./country";


export const CountryFlagIcon: React.FC<{ country: { code: string; name: string } }> = ({ country }) => (
  <img 
    className="inline-block size-4 rounded-full" 
    src={getCountryIconUrl(country.code)} 
    alt={country.name} 
  />
);
